<div [formGroup]="mainForm" id="top">
  <app-sg-aria-message [errorMessageModelArray]="errorMessageModelArray" />
  <h1>{{sgkd020dTitle}}</h1>
  <app-sgkd020d-search-condition
    [urlParamPayMethod]="urlParamPayMethod"
    (responseDirectEmitter)="setDirectResult($event)"
    (responseCreditEmitter)="setCreditResult($event)"
    (clearMessageEvent)="clearMessage()"
    (registEvent)="onClickRegist($event)"
    (deleteEvent)="onClickDelete($event)"
    (printEvent)="onClickPrint($event)"
  />
</div>
